const WORKOUTS_ENDPOINT = {
  WORKOUTS: '/workouts',
  RECOMMENDED: '/workouts/recommended',
  REGENERATE: '/workouts/regenerate',
  SHARE: '/workouts/share',
  SHARED: '/workouts/shared',
  CREATE_SMART: '/workouts/smart',
  UPLOAD_IMAGE: '/workouts/upload-image/:id',
  GET_SMART_SUGGESTION: '/workouts/smart-suggestion'
}

export default WORKOUTS_ENDPOINT
